var _rect, _rect2, _g, _rect3, _rect4, _path, _rect5, _path2, _circle, _circle2, _rect6, _rect7, _rect8, _rect9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoostAvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#E8F7CD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1816_35060",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 8,
    width: 19,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.0877,
    y: 8.62013,
    width: 17.491,
    height: 14.8829,
    fill: "#295C07",
    stroke: "black",
    strokeWidth: 0.842308
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1816_35060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.8749 13.0199H33.3099V12.5518H37.051V15.6408H36.3655V14.3584V13.4423L35.6701 14.0387L30.9027 18.1279L28.1213 15.7423L27.8471 15.5071L27.5729 15.7423L23.2638 19.4384L22.84 19.0749L27.848 14.7502L30.6285 17.1351L30.9014 17.3692L31.1753 17.1364L35.1476 13.762L36.0212 13.0199H34.8749Z",
    fill: "#295C07",
    stroke: "black",
    strokeWidth: 0.842308
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.366667,
    y: 0.366667,
    width: 1.71889,
    height: 6.81197,
    rx: 0.859444,
    transform: "matrix(0 1 1 0 11.8662 20.5994)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.733333
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.366667,
    y: 0.366667,
    width: 1.71889,
    height: 17.7526,
    rx: 0.859444,
    transform: "matrix(0 1 1 0 21.2979 37.574)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.733333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5079 25.4792C19.9899 25.4792 18.9753 27.0425 19.5934 28.4289L22.1163 34.0879C22.4533 34.8436 23.2033 35.3305 24.0308 35.3305H36.5938C37.6565 35.3305 38.551 34.5353 38.6756 33.4799L39.3433 27.821C39.4903 26.5746 38.5166 25.4792 37.2616 25.4792L21.5079 25.4792Z",
    fill: "#FFC0C0",
    stroke: "black",
    strokeWidth: 1.46667
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -0.281922,
    y: 0.435212,
    width: 1.60155,
    height: 19.0713,
    rx: 0.800776,
    transform: "matrix(-0.977909 0.209032 0.209032 0.977909 18.7733 20.5703)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.733333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9255 38.2673H22.1335V39.7764L24.7002 39.0007L23.9255 38.2673Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.93333,
    cy: 2.93333,
    r: 2.2,
    transform: "matrix(-1 0 0 1 38.2666 39.0017)",
    stroke: "black",
    strokeWidth: 1.46667
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.93333,
    cy: 2.93333,
    r: 2.2,
    transform: "matrix(-1 0 0 1 25.4482 39.0818)",
    stroke: "black",
    strokeWidth: 1.46667
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -0.37672,
    y: 0.275723,
    width: 0.660214,
    height: 5.94192,
    rx: 0.330107,
    transform: "matrix(-0.98823 -0.152975 -0.152975 0.98823 36.6252 27.3458)",
    fill: "#FF8484",
    stroke: "black",
    strokeWidth: 0.660214
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: -0.365865,
    y: 0.289972,
    width: 0.660214,
    height: 5.94192,
    rx: 0.330107,
    transform: "matrix(-0.993371 -0.114953 -0.114953 0.993371 32.6746 27.3346)",
    fill: "#FF8484",
    stroke: "black",
    strokeWidth: 0.660214
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: -0.281782,
    y: 0.372209,
    width: 0.660214,
    height: 5.94192,
    rx: 0.330107,
    transform: "matrix(-0.990576 0.136966 0.136966 0.990576 27.7988 27.327)",
    fill: "#FF8484",
    stroke: "black",
    strokeWidth: 0.660214
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: -0.220134,
    y: 0.411682,
    width: 0.660214,
    height: 5.94192,
    rx: 0.330107,
    transform: "matrix(-0.956987 0.29013 0.29013 0.956987 23.2652 27.3665)",
    fill: "#FF8484",
    stroke: "black",
    strokeWidth: 0.660214
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoostAvg);
export default __webpack_public_path__ + "static/media/Boost_avg.ae03ebbc5c992ccb38c43dc345004efe.svg";
export { ForwardRef as ReactComponent };